import styled from 'styled-components'

export const ForgotPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: ${({ theme }) => theme.mp.sm};
  box-shadow: 0px 2pt 3pt #00000029;
  background-color: ${({ theme }) => theme.palette.white};
  overflow: hidden;
  padding: ${({ theme }) => theme.mp.lg};
  width: 300px;

  @media only screen and (min-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 550px;
  }
`

export const Description = styled.p`
  color: ${({ theme }) => theme.palette.muted};
`

export const AlertText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.font.sizes.default};
  padding: 0 ${({ theme }) => theme.mp.md};
  font-weight: ${({ theme }) => theme.font.weights.regular};
  line-height: ${({ theme }) => theme.font.sizes.large};
`

export const BackToLoginLabel = styled.label`
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.muted};
  transition-duration: 0.2s;

  &:hover {
    color: ${({ theme }) => theme.palette.primary};
  }
`

export const FieldLabel = styled.label`
  display: block;
  position: relative;
  color: ${({ theme }) => theme.palette.dark};
  flex: 1;
  white-space: nowrap;
  padding: ${({
    theme: {
      mp: { xs, sm },
    },
  }) => `${xs} ${sm} ${xs} 0`};
  font-weight: ${({ theme }) => theme.font.weights.semiBold};
  font-size: ${({ theme }) => theme.font.sizes.default};
`

export const Heading = styled.h2`
  display: block;
  margin-bottom: ${({ theme }) => theme.mp.xs};
  font-weight: ${({ theme }) => theme.font.weights.semiBold};
  line-height: ${({ theme }) => theme.font.sizes.large};
  color: ${({ theme }) => theme.palette.dark};
`

export const LogoImg = styled.img`
  margin-bottom: ${({ theme }) => theme.mp.md};
  width: 100px;
`
